/* global loadStatesAndProvinces, isOverEighteen, updateIntlPhoneFlag a*/


/**
 * create_account handles the Swiper and form steps for a new full-page account creation
 * This is part of the new Rider Funnel experience
 */
SC.create_account = (function () {
  var api = {};

  var init = function () {
    if (!$('body').hasClass('new_rider_create_account') && !$('#dob_new_rider').hasClass('new_rider_create_account')) {
      return;
    }

    handleEvents();
  };

  var handleEvents = function  () {
    initializeAccountCreation();
  };

  /**
   * initializeAccountCreation handles all the events for each step of account creation and login page
   *
   * Signup pages have multiple of the same IDs, so we specify a parent class
   * there are multiple signup forms within any given signup page. Why? ¯\_(ツ)_/¯
   * @returns {void}
   */
  var initializeAccountCreation = function () {
    var $form              = $('form.account-creation__form');
    var $backButton        = $('#handle-back');
    var $doneButton        = $('#handle-done');
    var $formError         = $('.global-form__error');
    var $inputs            = $('.account-creation__form__swiper__slide input');
    var $nextButton        = $('#handle-next');
    var $notNewLink        = $('#handle-not-new');
    var $progressBar       = $('#auth-swiper-progress');
    var $stepStatus        = $('#auth-swiper-step-status');
    var $analyticsLocation = $('#analytics_location');

    var $dobPlaceholder       = $('#dob_placeholder-input');
    var $locationPlaceholder  = $('#location_placeholder-input');
    var $dobDayInput          = $('.global__input-select-dob_group > #frm-dob_day');
    var $dobMonthInput        = $('.global__input-select-dob_group > #frm-dob_month');
    var $dobYearInput         = $('.global__input-select-dob_group > #frm-dob_year');
    var $dobHint              = $('#dob-hint');
    var $countryInput         = $('.global__input-select-location_group > #frm-country');
    var $stateSelect          = $('.global__input-select-location_group > #frm-state');

    var $optSellingContainer  = $('#opt_selling-container');
    var $optSellingCheckbox   = $('#opt_selling-checkbox');

    var $optSmsContainer        = $('#optin_sms-container');
    var $optSmsCheckbox         = $('#optin_sms-checkbox');

    var $optMarketingContainer  = $('#optout_marketing-container');
    var $optMarketingCheckbox   = $('#optout_marketing-checkbox');
    var $riderCountry           = $('#rider_country');
    var $riderState             = $('#rider_state');
    var $selectedDay = $('#rider_bd_day').text();
    var $selectedMonth = $('#rider_bd_month').text();
    var $selectedYear = $('#rider_bd_year').text();
    var $selectedCountry = $riderCountry.text();
    var $selectedState = $riderState.text();
    var $handleCreateAccount = $('#handle-create-account');
    var analyticsLocationVal = $analyticsLocation.val();
    var location = (analyticsLocationVal && analyticsLocationVal.length > 0) ? analyticsLocationVal : 'New Rider';
    // set up the default swiper data
    var swiperData = {
      autoplay: false,
      centeredSlides: true,
      loop: false,
      autoplayDisableOnInteraction: false,
      speed: 400,
      freeMode: false,
      slidesPerView: 2,
      spaceBetween: 100,
      onlyExternal: true,
      // With onlyExternal, any pointer movement during a press sets allowClick=false and
      // Swiper's capture-phase click handler then preventDefault()s the click, silently
      // cancelling checkbox toggles and other control clicks inside the slides. Swiping
      // is disabled anyway, so click suppression serves no purpose here.
      preventClicks: false,
      preventClicksPropagation: false,
      slideClass: 'account-creation__form__swiper__slide',
      slideActiveClass: 'account-creation__form__swiper__slide--active',
      breakpoints: {
        320: {
          slidesPerView: 1,
          spaceBetween: 10
        },
        480: {
          slidesPerView: 1,
          spaceBetween: 20
        },
        640: {
          slidesPerView: 1,
          spaceBetween: 30
        },
        768: {
          slidesPerView: 1,
          spaceBetween: 50
        },
        1023: {
          slidesPerView: 1
        }
      }
    };

    var swiper = new Swiper('.account-creation__form__swiper-container', swiperData);
    swiper.on('transitionEnd', function () {
      updateInputsStates();
    });

    /**
     * gets the scaleX value as a string to set to a css transform
     * If we have 3 slides, we want the progress bar to be split into 4.
     * If we are on the third slide, the progress should be at 75%.
     * 100% is reached after the done button click
     *
     * @param {boolean} completed indicating if we've reached the last available slide and exiting(done button)
     * @return {string} css scaleX
     */
    var getScaleX = function (completed) {
      // store the total steps
      var totalSteps = swiper.slides.length + 1;
      // get the original scale
      var originalScale = 1 / totalSteps;

      // if this is the first slide return the original scale
      if (swiper.activeIndex === 0) {
        return 'scaleX(' + originalScale + ')';
      }

      // if the slide process has completed the active slide is equal to the totelsteps
      // else it's equal to the current slide (activeIndex is zero based)
      var activeSlide = completed ? totalSteps : swiper.activeIndex + 1;

      return 'scaleX(' + (activeSlide * originalScale) + ')';
    };

    /**
     * handleStepButtons display/hide the buttons and disables/enable the inputs
     * @returns {void}
     */
    var handleStepButtons = function () {
      if (swiper.activeIndex === 0) {
        $notNewLink.removeClass('hidden');
        $backButton.addClass('hidden');
        // Show sign up with google and apple buttons on step 1
        $('.external-provider-signup-buttons').show();
      } else {
        $notNewLink.addClass('hidden');
        $backButton.removeClass('hidden');
        // Hide sign up with google and apple buttons on step 2 and later
        $('.external-provider-signup-buttons').hide();
      }
    };

    /**
     * validateStepOne send the request to validate step one of account creation
     * @returns {void}
     */
    var validateStepOne = function () {
      $form.clearFormErrors();
      $inputs.prop('disabled', false);
      normalizeDobInputs();

      var invalidDobFieldName = getInvalidDobFieldName();

      if (invalidDobFieldName) {
        var dobFieldErrors = {};

        dobFieldErrors[invalidDobFieldName] = 'Enter a valid date of birth';
        handleFormFieldErrors({ fieldErrors: dobFieldErrors });
        // false: keep focus management here so the rider lands on the
        // offending date input instead of the first input of the slide.
        updateInputsStates(false);
        $form.find('[name=' + invalidDobFieldName + ']').focus();
        $nextButton.prop('disabled', false);
        return;
      }

      $form.ajaxSubmit({
        url: '/register/step-1/',
        dataType: 'json',
        success: function (data) {
          $form.updateCsrfToken();
          var eventData;

          if (data.success) {
            swiper.slideNext();
            handleStepButtons(swiper, $inputs);
            updateProgressBar();
            updateSwiperContainerClass();

            // Load terms and checkboxes for step 2 (the final step)
            SC.authentication.getTerms();
            $nextButton.hide();
            $doneButton.show();

            // set defaults for checkbox
            $optSellingContainer.hide();
            $optMarketingContainer.hide();

            // check for cases where it is a string (we evaluate falsy above)
            if (data.checkbox && data.checkbox !== false) {
              displayOptCheckbox(data.checkbox);
            }

            /**
             * mParticle sendEvent - Click Sign Up CTA 1 - Success
             * Sends mParticle event with a label for GA Event.
             */
            eventData = {
              'Response': 'Success',
              'Location': location,
              'Step': 1
            };
            SC.analytics.mp.sendEvent('Click Sign Up CTA 1', 'navigation', eventData, location);
            $nextButton.prop('disabled', false);
            return;
          } else if (data.redirect && data.error === 'error-under-13') {
            /**
             * mParticle sendEvent - Click Sign Up CTA 1 - Invalid
             * Sends mParticle event with a label for GA Event.
             */
            eventData = {
              'Response': 'User is underage error (' + data.redirect.error + ')',
              'Location': location,
              'Step': 1
            };
            SC.analytics.mp.sendEvent('Click Sign Up CTA 1', 'navigation', eventData, location);
            window.location.replace(data.redirect.url);
          } else {
            /**
             * mParticle sendEvent - Click Sign Up CTA 1 - Invalid
             * Sends mParticle event with a label for GA Event.
             */
            eventData = {
              'Response': 'Invalid email or password',
              'Location': location,
              'Step': 1
            };
            SC.analytics.mp.sendEvent('Click Sign Up CTA 1', 'navigation', eventData, location);

            handleFormFieldErrors(data);
            updateInputsStates();
            $nextButton.prop('disabled', false);
          }
        },
        error: function (jqXHR, status, errorThrown) {
          $form.updateCsrfToken();

          // Log mParticle Click Sign Up CTA 1 event - Response: Server Error
          var eventData = {
            'Response': 'Server Error - status: ' + status + ', error: ' + errorThrown,
            'Location': location,
            'Step': 1
          };
          SC.analytics.mp.sendEvent('Click Sign Up CTA 1', 'navigation', eventData, location);

          // Display the Error Message and update the input state.
          $formError.text(genericErrorMessage);
          updateInputsStates(false);
          $nextButton.prop('disabled', false);
        }
      });
    };

    /**
     * validateStepTwo send the request to validate step two of account creation
     * @returns {void}
     */
    var validateStepTwo = function () {
      $form.clearFormErrors();
      $inputs.prop('disabled', false);

      $form.ajaxSubmit({
        url: '/register/step-2/',
        dataType: 'json',
        success: function (data) {
          var eventData;

          $form.updateCsrfToken();

          if (data.success) {
            $inputs.prop('disabled', false);
            updateProgressBar(true);
            updateSwiperContainerClass();
            registerNewRider();

            /**
             * mParticle sendEvent - Click Sign Up CTA 2 - Success
             * Sends mParticle event with a label for GA Event.
             */
            eventData = {
              'Response': 'Success',
              'Location': location,
              'Step': 2
            };
            SC.analytics.mp.sendEvent('Click Sign Up CTA 2', 'navigation', eventData, location);

            return;
          }

          /**
           * mParticle sendEvent - Click Sign Up CTA 2 - Invalid
           * Sends mParticle event with a label for GA Event.
           */
          eventData = {
            'Response': 'Invalid First Name, Last Name or Phone Number, Emergency Contact Name, Emergency Phone Number or Terms & Conditions',
            'Location': location,
            'Step': 2
          };
          SC.analytics.mp.sendEvent('Click Sign Up CTA 2', 'navigation', eventData, location);

          handleFormFieldErrors(data);
          updateInputsStates();
          $doneButton.prop('disabled', false);
          $nextButton.prop('disabled', false);
        },
        error: function (jqXHR, status, errorThrown) {
          $form.updateCsrfToken();

          var eventData = {
            'Response': 'Server Error - status: ' + status + ', error: ' + errorThrown,
            'Location': location,
            'Step': 2
          };
          SC.analytics.mp.sendEvent('Click Sign Up CTA 2', 'navigation', eventData, location);

          $formError.text(genericErrorMessage);
          updateInputsStates(false);
          $nextButton.prop('disabled', false);
        }
      });
    };

    /**
     * registerNewRider send the request to register the new rider
     * @returns {void}
     */
    var registerNewRider = function () {
      $form.clearFormErrors();
      $doneButton.prop('disabled', true);

      var capturedEmail = SC.analytics.mp.getEmailAttribute();
      $form.ajaxSubmit({
        url: '/register/',
        dataType: 'json',
        success: function (data) {
          var eventData;

          $form.updateCsrfToken();

          if (data.success) {
            var emailWasCaptured = data.rider && capturedEmail && data.rider.email === capturedEmail;
            /**
             * mParticle User Identity - setup user
             */
            // If user being registered is NOT the same that was captured previously
            if (!emailWasCaptured) {
              SC.analytics.mp.userEvent('remove');
            }

            var userEventPromise = SC.analytics.mp.userEvent('setup', data.rider_id.toString());

            userEventPromise.then(function () {
              /**
               * mParticle sendEvent - Account Creation Response - Success
               * Sends mParticle event with a label for GA Event.
               */

              eventData = {
                'Response': 'Success',
                'Location': location,
                'Step': 2
              };

              if (data.rider.do_not_sell_approved && data.rider.do_not_sell_approved === true) {
                SC.analytics.mp.setupConsent(Date.now(), '', location);
              }

              SC.analytics.mp.userEvent('attribute', data.rider.first_name.toString(), 'first_name');
              SC.analytics.mp.userEvent('attribute', data.rider.phone_number.toString(), 'phone');
              SC.analytics.mp.userEvent('attribute', data.rider.email, 'email');
              SC.analytics.mp.userEvent('attribute', 1, 'has_account');
              SC.analytics.mp.sendEvent('Account Creation Response', 'navigation', eventData, location);

              if (emailWasCaptured) {
                SC.analytics.mp.sendEvent('Create Account Since Email Capture', 'navigation');
              }
            }).fail(function (error) {
              eventData = {
                'Response': 'Server Error - error: ' + error,
                'Location': location,
                'Step': 3
              };
              SC.analytics.mp.sendEvent('Account Creation Response', 'navigation', eventData, location);
            }).always(function () {
              if (data.url) {
                window.location.replace(data.url);
              } else {
                window.location.reload();
              }
            });

            return;
          }

          /**
           * mParticle sendEvent - Account Creation Response - Invalid
           * Sends mParticle event with a label for GA Event.
           */
          eventData = {
            'Response': 'Invalid email, password, First Name, Last Name or Phone Number, Emergency Contact Name, Emergency Phone Number or Terms & Conditions',
            'Location': location,
            'Step': 'Step 2'
          };
          SC.analytics.mp.sendEvent('Account Creation Response', 'navigation', eventData, location);

          handleFormFieldErrors(data);
          $doneButton.prop('disabled', false);
        },
        error: function (jqXHR, status, errorThrown) {
          $form.updateCsrfToken();

          var eventData = {
            'Response': 'Server Error - status: ' + status + ', error: ' + errorThrown,
            'Location': location,
            'Step': 2
          };
          SC.analytics.mp.sendEvent('Account Creation Response', 'navigation', eventData, location);

          $formError.text(genericErrorMessage);
          updateInputsStates();
          $doneButton.prop('disabled', false);
        }
      });
    };

    /**
     * handles the form field errors for each slide
     *
     * @param {object} data data returned from ajax request
     * @returns {void}
     */
    var handleFormFieldErrors = function (data) {
      var $activeSlide = $('.account-creation__form__swiper__slide--active');

      if (data.recaptchaRequired) {
        $form.resetRecaptcha();

        if ($form.recaptchaError(data.message)) {
          return;
        }
      }

      if (data.fieldErrors) {
        $form.fieldErrors(data.fieldErrors);
        $activeSlide.find('.global__input__text').hide();
      }

      if (!data.fieldErrors) {
        $formError.text(data.message || genericErrorMessage);
      }
    };

    /**
     * updateInputsStates enables current step `inputs` and disables the other steps `inputs`.
     *
     * @param {object} firstActiveInput the first active input
     * @returns {void}
     */
    var updateInputsStates = function (firstActiveInput) {
      var focusFirstActiveInput = (typeof firstActiveInput !== 'undefined') ? firstActiveInput : true;
      $inputs.prop('disabled', true);
      var $slides = $('.account-creation__form__swiper__slide');
      var $activeSlide = $('.account-creation__form__swiper__slide--active');
      var $activeInputs = $activeSlide.find('input');

      // Keep inactive slides out of the tab order and the accessibility tree so keyboard
      // users are not stranded on off-screen fields, terms links, or the scrollable terms
      // region before reaching the step buttons underneath the form.
      $slides.not($activeSlide).attr('aria-hidden', 'true').prop('inert', true);
      $activeSlide.removeAttr('aria-hidden').prop('inert', false);

      // This is to take out of the keyword tab selections the disable flags div's
      $('.account-creation__form__swiper__slide .selected-flag').each(function () {
        $(this).attr('tabindex', '-1');
      });

      $('.account-creation__form__swiper__slide--active .selected-flag').each(function () {
        var $selectedFlag = $(this);
        $selectedFlag.attr('tabindex', $selectedFlag.attr('tabindex-bck'));
      });

      $activeInputs.prop('disabled', false);
      if (focusFirstActiveInput) {
        $activeInputs.first().focus();
      }
    };

    /**
     * updates the progressbar based on the step we're on.
     *
     * @param {boolean} completed indicating if we've completed the swiping and exiting(done button)
     * @returns {void}
     */
    var updateProgressBar = function (completed) {
      if (!$progressBar) {
        return;
      }

      $progressBar.css('transform', getScaleX(completed));

      var totalSlides = swiper.slides.length;
      var currentStep = completed ? totalSlides : swiper.activeIndex + 1;
      var stepText = 'Step ' + currentStep + ' of ' + totalSlides;

      $progressBar.attr('aria-valuemax', totalSlides);
      $progressBar.attr('aria-valuenow', currentStep);
      $progressBar.attr('aria-valuetext', stepText);
      $stepStatus.text(stepText);
    };

    var updateSwiperContainerClass = function () {
      if (swiper.activeIndex === 2) {
        swiper.container.addClass('swiper-container--third-slide');
      } else {
        swiper.container.removeClass('swiper-container--third-slide');
      }
    };

    /**
     * Order the date of birth inputs to match the selected country's convention:
     * month first for the US, day first everywhere else. Moving the wrapper nodes
     * keeps typed values and puts the tab order in the visual order. The format
     * hint under the legend is kept in step with the field order.
     *
     * @param {string} country the selected country code
     * @return {void}
     */
    var updateDobInputOrder = function (country) {
      var $dayItem = $dobDayInput.parent();
      var $monthItem = $dobMonthInput.parent();

      if (country === 'US') {
        $monthItem.insertBefore($dayItem);
        $dobHint.text('For example, 3 27 1990');
      } else {
        $dayItem.insertBefore($monthItem);
        $dobHint.text('For example, 27 3 1990');
      }
    };

    /**
     * Rebuild the state/province <select> with a labelled placeholder option, keeping
     * the chosen (or prefilled) state when it exists in the rebuilt list.
     *
     * Wraps the shared loadStatesAndProvinces(), which auto-selects the first US state;
     * the legacy signup pages still rely on that behavior.
     *
     * @param {string|null} country the country code to load states for
     * @return {void}
     */
    var refreshStateOptions = function (country) {
      var currentState = $stateSelect.val();
      var chosenState = currentState === null ? $riderState.text() : currentState;

      loadStatesAndProvinces(country);

      var stateLabel = $('#state-label').text() || 'State';
      var $placeholderOption = $stateSelect.find('option[value=""]');

      if ($placeholderOption.length) {
        $placeholderOption.text(stateLabel);
      } else {
        $stateSelect.prepend('<option value="">' + stateLabel + '</option>');
      }

      var chosenStateExists = chosenState !== '' && $stateSelect.find('option').filter(function () {
        return this.value === chosenState;
      }).length > 0;

      $stateSelect.val(chosenStateExists ? chosenState : '');
    };

    refreshStateOptions();

    if ($selectedDay && $selectedMonth && $selectedYear) {
      $dobMonthInput.val($selectedMonth);
      $dobDayInput.val($selectedDay);
      $dobYearInput.val($selectedYear);
      $dobPlaceholder.val('false');
    }

    if ($selectedCountry && $selectedState) {
      $locationPlaceholder.val('false');
    }

    updateDobInputOrder($countryInput.val());
    /**
     * Add appropriate attributes to the checkbox field so submission works
     * opt_in_selling is always true by default, and set to 0 (false) depending on logic for children
     *
     * @param {string} checkboxName Either `opt_in_selling` or `opt_out_marketing`
     * @return {void}
     */
    var displayOptCheckbox = function (checkboxName) {
      $('#optin_optout_checkbox').css('display', 'flex');

      $optSellingCheckbox.val('1');
      $optSellingCheckbox.prop('checked', true);

      $optMarketingCheckbox.val('0');
      $optMarketingCheckbox.prop('checked', false);

      $optSmsCheckbox.val('0');
      $optSmsCheckbox.prop('checked', false);

      /* eslint indent: ["error", 2, { "SwitchCase": 1 }]*/
      switch (checkboxName) {
        case 'opt_in_selling':
          $optSellingContainer.css('display', 'flex');

          $optSellingCheckbox.val('0');
          $optSellingCheckbox.prop('checked', false);
          break;
        case 'opt_out_marketing':
          $optMarketingContainer.css('display', 'flex');
          break;
        case 'opt_in_sms':
          $optSmsContainer.css('display', 'flex');
          break;
        default:
          console.error('No appropriate option found.');
          break;
      }
    };

    /**
     * Whether the typed date of birth is not yet a plausible full date
     * (month 1-12, day 1-31, four-digit year).
     *
     * @return {boolean} true while the date of birth is incomplete or non-numeric
     */
    var isDobIncomplete = function () {
      var month = parseInt($dobMonthInput.val(), 10);
      var day = parseInt($dobDayInput.val(), 10);
      var year = parseInt($dobYearInput.val(), 10);

      return isNaN(month) || month < 1 || month > 12 ||
        isNaN(day) || day < 1 || day > 31 ||
        isNaN(year) || String($dobYearInput.val()).trim().length < 4;
    };

    /**
     * Whether the typed date parts name an impossible calendar date such as
     * February 31. JavaScript's Date silently rolls those over into the next
     * month, so the built date is compared back against the typed parts.
     *
     * @return {boolean} true when the complete date does not exist on the calendar
     */
    var isDobInvalid = function () {
      if (isDobIncomplete()) {
        return false;
      }

      var month = parseInt($dobMonthInput.val(), 10);
      var day = parseInt($dobDayInput.val(), 10);
      var year = parseInt($dobYearInput.val(), 10);
      var date = new Date(year, month - 1, day);

      return date.getFullYear() !== year || date.getMonth() !== month - 1 || date.getDate() !== day;
    };

    /**
     * Which date of birth input is responsible for a malformed date, so the
     * inline error and focus land on the offending part: the month when it is
     * out of range, the year when it is short or non-numeric, and the day when
     * it is out of range or names an impossible calendar date such as 2/31.
     * Any still-empty part is left to the backend's required-field messages.
     *
     * @return {string|null} the offending input's name attribute, or null when the date is fine or a part is empty
     */
    var getInvalidDobFieldName = function () {
      var monthValue = $.trim($dobMonthInput.val());
      var dayValue = $.trim($dobDayInput.val());
      var yearValue = $.trim($dobYearInput.val());

      if (monthValue === '' || dayValue === '' || yearValue === '') {
        return null;
      }

      var month = parseInt(monthValue, 10);
      var day = parseInt(dayValue, 10);
      var year = parseInt(yearValue, 10);

      if (isNaN(month) || month < 1 || month > 12) {
        return 'dob_month';
      }

      if (isNaN(year) || yearValue.length < 4) {
        return 'dob_year';
      }

      if (isNaN(day) || day < 1 || day > 31 || isDobInvalid()) {
        return 'dob_day';
      }

      return null;
    };

    // The backend rejects zero-padded date parts ("06"), so typed values are
    // normalized to plain integers; empty or non-numeric values are left for the
    // backend's own validation messages.
    var normalizeDobInputs = function () {
      $dobMonthInput.add($dobDayInput).add($dobYearInput).each(function () {
        var numericValue = parseInt(this.value, 10);

        if (!isNaN(numericValue)) {
          $(this).val(numericValue);
        }
      });
    };

    var checkAgeEligibility = function () {
      if (isDobIncomplete() || isDobInvalid()) {
        $formError.text('');
        return;
      }

      if (!isOverEighteen()) {
        $formError.text('If you are under 18, registration must be completed in person, at one of our studios, ' +
          'accompanied by a parent or guardian who must sign a Minor New Rider Waiver Form for you. After this is complete, ' +
          'you may sign up for SoulCycle classes online. Riders must be at least at least 12 years of age, meet the minimum height requirement of 4\'11"');
      } else {
        $formError.text('');
      }
    };
    // Nette forms is causing an override cause of the swiper, target the phone numbers directly
    $('#phone-input, #emergency_contact_phone-input').on('click', function () {
      $(this).focus();
    });

    $handleCreateAccount.on('click', function (e) {
      e.preventDefault();
      normalizeDobInputs();
      const locationError = $('#location-error');
      const dobError = $('#dob-error');
      const firstNameError = $('#first-name-error');
      const lastNameError = $('#last-name-error');
      const firstName = $('#first_name-input').val();
      const lastName = $('#last_name-input').val();
      const phoneError = $('#phone-number-error');
      const emergencyContactNameError = $('#emergency-contact-name-error');
      const emergencyContactNumberError = $('#emergency-contact-number-error');
      const emergencyContactName = $('#emergency_contact_name-input').val();
      const phoneValue = $('#phone-input').val();
      const emergencyPhoneValue = $('#emergency_contact_phone-input').val();

      if (phoneValue === '') {
        phoneError.text('Add a phone number');
      } else if (!/^[\d\s+()-]+$/.test(phoneValue)) {
        phoneError.text('Please enter a valid phone number');
      } else {
        phoneError.text('');
      }

      if (typeof firstName !== 'undefined') {
        if (firstName === '') {
          firstNameError.text('Add first name');
        } else if (firstName.length > 32) {
          firstNameError.text('First name must be 32 characters or less');
        } else if (!/^(?=.*\p{L})[\p{L}\s'.-]+$/u.test(firstName)) {
          firstNameError.text('First name should start with a letter and can only contain letters, spaces, apostrophes, hyphens, and periods');
        } else {
          firstNameError.text('');
        }
      }

      if (typeof lastName !== 'undefined') {
        if (lastName === '') {
          lastNameError.text('Add last name');
        } else if (lastName.length > 32) {
          lastNameError.text('Last name must be 32 characters or less');
        } else if (!/^(?=.*\p{L})[\p{L}\s'.-]+$/u.test(lastName)) {
          lastNameError.text('Last name should start with a letter and can only contain letters, spaces, apostrophes, hyphens, and periods');
        } else {
          lastNameError.text('');
        }
      }

      if (emergencyContactName === '') {
        emergencyContactNameError.text('Add an emergency contact name');
      } else if (emergencyContactName.length > 60) {
        emergencyContactNameError.text('Emergency contact name must be 60 characters or less');
      } else if (!/^(?=.*\p{L})[\p{L}\s'.-]+$/u.test(emergencyContactName)) {
        emergencyContactNameError.text('Emergency contact name should start with a letter and can only contain letters, spaces, apostrophes, hyphens, and periods');
      } else {
        emergencyContactNameError.text('');
      }

      if (emergencyPhoneValue === '') {
        emergencyContactNumberError.text('Add an emergency contact number');
      } else if (!/^[\d\s+()-]+$/.test(emergencyPhoneValue)) {
        emergencyContactNumberError.text('Please enter a valid emergency contact number');
      } else {
        emergencyContactNumberError.text('');
      }

      if (isDobIncomplete()) {
        dobError.text('Enter your date of birth.');
      } else if (isDobInvalid()) {
        dobError.text('Enter a valid date of birth.');
      } else  {
        var tempDate = new Date(parseInt($dobYearInput.val(), 10) + 18, parseInt($dobMonthInput.val(), 10) - 1, $dobDayInput.val());
        if (tempDate > new Date()) {
          dobError.text('If you are under 18, registration must be completed in person, at one of our studios, ' +
            'accompanied by a parent or guardian who must sign a Minor New Rider Waiver Form for you. After this is complete, ' +
            'you may sign up for SoulCycle classes online. Riders must be at least at least 12 years of age, meet the minimum height requirement of 4\'11"');
        } else {
          dobError.text('');
        }
      }

      if ( !$('#frm-country').val() || !$('#frm-state').val()) {
        locationError.text('Select country and state.');
      } else  {
        locationError.text('');
      }

      if (locationError.text() === ''
        && dobError.text() === ''
        && phoneError.text() === ''
        && firstNameError.text() === ''
        && lastNameError.text() === ''
        && emergencyContactNameError.text() === ''
        && emergencyContactNumberError.text() === ''
      ) {
        $('#complete_rider_info').submit();
      }
    });

    $nextButton.on('click', function () {
      $nextButton.prop('disabled', true);
      var currentStep = swiper.activeIndex + 1;
      $doneButton.hide();
      $form.clearFormErrors();

      if (currentStep === 1) {
        validateStepOne();
      } else {
        $nextButton.hide();
        $doneButton.show();
      }
      $('.global__input__text').show();
    });

    // Handles the `back` button logic for step 2
    $backButton.on('click', function () {
      $form.updateCsrfToken();
      $nextButton.show();
      $doneButton.hide();
      $form.clearFormErrors();
      swiper.slidePrev();
      handleStepButtons(swiper, $inputs);
      updateProgressBar();
      updateSwiperContainerClass();

      var currentStep = swiper.activeIndex + 1;
      var eventData = {
        'Location': location,
        'Context': 'Sign Up',
        'Step': currentStep
      };
      SC.analytics.mp.sendEvent('Click Back', 'navigation', eventData, location);
      $('.global__input__text').show();
    });

    // Handles the `done` button logic to register the new rider
    $doneButton.on('click', function () {
      $doneButton.prop('disabled', true);
      validateStepTwo();
    });

    $notNewLink.on('click', function () {
      var eventData = {
        'Location': location,
        'Context': 'Sign Up',
        'Step': 1
      };
      SC.analytics.mp.sendEvent('Click to Log In', 'navigation', eventData, location);
    });

    $inputs.on('keydown', $form, function (e) {
      if (e.key === 'Enter') {
        e.preventDefault();
        if (swiper.activeIndex < 1) {
          $nextButton.trigger('click');
        } else {
          $doneButton.trigger('click');
        }
      }
    });

    $dobMonthInput.add($dobDayInput).add($dobYearInput).on('change', function () {
      normalizeDobInputs();
      checkAgeEligibility();
    });

    $countryInput.change(function () {
      window.soulcycle.countryCode = $(this).val();

      $riderCountry.text(this.value);
      $riderState.text('');
      refreshStateOptions(this.value);
      updateDobInputOrder(this.value);
      updateIntlPhoneFlag();
      checkAgeEligibility();
    });

    // Keep the original value attributes and sync them from the checked state on
    // the change event, which fires for keyboard (Space) and mouse alike, so the
    // submitted value can never desync from what the user toggled.
    $optSellingCheckbox.add($optMarketingCheckbox).add($optSmsCheckbox).on('change', function () {
      $(this).val(this.checked ? '1' : '0');
    });

    // The hidden dob/location placeholder inputs are frontend-only sentinels: empty means
    // untouched (the backend answers "Date of Birth is required"), 'false' means the user
    // engaged the fields, telling the backend to validate the field values instead.
    $dobMonthInput.add($dobDayInput).add($dobYearInput).on('input change', function () {
      $dobPlaceholder.val('false');
    });

    $('.location_group_ctr select').on('change', function () {
      $locationPlaceholder.val('false');
    });

    updateProgressBar();

    // We need to wait for intl phone inputs to be initialized
    setTimeout(function () {
      $('.account-creation__form__swiper__slide .selected-flag').each(function () {
        var $selectedFlag = $(this);
        $selectedFlag.attr('tabindex-bck', $selectedFlag.attr('tabindex'));
        $selectedFlag.attr('tabindex', '-1');
      });
      updateInputsStates(false);
    }, 300);
  };

  init();

  return api;
}());
